// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoadingPage_loader__1iFSW","spinner":"LoadingPage_spinner__1X5bo"};